import React from 'react';

import { flagStyles } from '../settings';

const SvgMP = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3528px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMP;
